import Layout from '../../companyAdmin/layout.vue'
import List from './list.vue'

const basePath = '/v-admin/client-admin/open-api'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_COMPANY_APPROVAL'],
    menu: {
      labelI18nKey: 'admin.openApi.menu'
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,

      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.openApi.menu'
      }
    }
  ]
}
